/** @module app.test */

import { autoinject, Container } from 'aurelia-framework';
import { ITestFixture, ITest, ITestFixtureDefinition } from 'app/test/types';
import { testFixtureDefinitionSymbol } from 'app/test/symbols';
import { TestContext } from 'app/test/context';

@autoinject
export class TestResolver {

    constructor(private readonly container: Container) { }

    public async resolveTests(context: TestContext, module: any): Promise<ITest[]> {
        const tests: ITest[] = [];

        if(!module) { return tests; }

        for(const key in module) {
            const item = module[key];

            if(typeof item !== 'function') { continue; }
            if(!item.hasOwnProperty(testFixtureDefinitionSymbol)) { continue; }

            const testFixture: ITestFixtureDefinition = (<any>item)[testFixtureDefinitionSymbol];

            // construct object
            const fixtureInstance = this.container.get(item) as ITestFixture;
            if(!fixtureInstance) { continue; }

            fixtureInstance.context = context;
            fixtureInstance.assert = context.assert;

            for(const definition of testFixture.tests) {
                const testFunction = fixtureInstance[definition.name] as Function;
                if(!(testFunction instanceof Function)) { continue; }

                const testCases = [...definition.cases];
                if(testCases.length === 0) {
                    // add default case
                    testCases.push({ name: '', args: [] });
                }

                let anonIndex = 0;
                for(const testCase of testCases) {
                    let caseSuffix: string = '';
                    if(testCase.name) {
                        caseSuffix += ` (${testCase.name})`;
                    }
                    else if(testCases.length > 1) {
                        caseSuffix += ` #${++anonIndex}`;
                    }

                    let args = '';
                    if(testCase.args.length > 0) {
                        args = JSON.stringify(testCase.args, null, 4);
                        args = args.substr(1, args.length - 2); // trim []
                    }

                    const test: ITest = {
                        fixture: testFixture.name,
                        name: `${definition.name}${caseSuffix}`,
                        args: args,
                        run: () => (testFunction.apply(fixtureInstance, testCase.args))
                    };

                    tests.push(test);
                }
            }
        }

        return tests;
    }

}
